// firebase/config.js
import { initializeApp } from 'firebase/app';
import {
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  // Firebase 콘솔에서 가져온 설정값들
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

// 받은 데이터를 기기(IndexedDB)에 남겨 둔다.
// 휴대폰이 앱을 껐다 다시 열 때 책과 기록을 서버에서 전부 다시 받을 때까지 기다리지 않고
// 남겨 둔 것부터 바로 그린 뒤 바뀐 것만 받는다. 연결이 끊긴 채 남긴 기록도 앱이 꺼져도
// 사라지지 않고 다시 연결되면 올라간다. 여러 탭(브라우저 + 설치한 앱)이 함께 써도 된다.
// IndexedDB 를 쓸 수 없는 환경이면 Firestore 가 알아서 메모리 캐시로 돌아간다.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const auth = getAuth(app);